export const columns = [
    {
        title:'序号',
        type:'index'
    },
    // {
    //     title:'启用状态',
    //     dataIndex:"type",
    //     key:"type",
    //     slots:'type',
    // },
    {
        title:'姓名',
        dataIndex:"name",
        key:"name",
    },
    // {
    //     // title:'用户名',
    //     title:'手机号',
    //     dataIndex:"loginName",
    //     key:"loginName"
    // },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone",
    },
    {
        title:'操作人',
        dataIndex:"creatorName",
        key:"creatorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]